import { Form, Link, useLocation } from '@remix-run/react'
import { useRef, useState } from 'react'
import { getUserImgSrc } from '#app/utils/misc'
import { useUser } from '#app/utils/user'
import { Spacer } from './spacer'
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar'
import { Button } from './ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from './ui/dropdown-menu'
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from './ui/sheet'

export function UserNav() {
	const { pathname } = useLocation()
	const user = useUser()
	const formRef = useRef<HTMLFormElement>(null)
	const [isOpen, setIsOpen] = useState(false)

	const fallbackInitials = user?.name?.[0] || ''
	return (
		<>
			{/* desktop */}
			<div className="hidden sm:block">
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="ghost" className="relative h-8 w-8 rounded-full">
							<Avatar className="h-9 w-9">
								<AvatarImage
									src={getUserImgSrc(user.image?.id)}
									alt={user.name || user.username}
								/>
								<AvatarFallback>{fallbackInitials}</AvatarFallback>
							</Avatar>
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent className="w-56" align="end" forceMount>
						<DropdownMenuLabel className="font-normal">
							<div className="flex flex-col space-y-1">
								<p className="text-sm font-medium leading-none">{user.name}</p>
								<p className="text-xs leading-none text-muted-foreground">
									{user.email}
								</p>
							</div>
						</DropdownMenuLabel>
						<DropdownMenuSeparator />
						<DropdownMenuGroup>
							<DropdownMenuItem asChild>
								<Link to="/settings/profile">Profile</Link>
							</DropdownMenuItem>
						</DropdownMenuGroup>
						<DropdownMenuSeparator />
						<Form action="/logout" method="POST" ref={formRef}>
							<DropdownMenuItem>
								<button type="submit">Log out</button>
							</DropdownMenuItem>
						</Form>
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
			{/* mobile */}
			<div className="sm:hidden">
				<Sheet open={isOpen} onOpenChange={setIsOpen}>
					<SheetTrigger asChild>
						<Button variant="ghost" className="relative h-8 w-8 rounded-full">
							<Avatar className="h-9 w-9">
								<AvatarImage
									src={getUserImgSrc(user.image?.id)}
									alt={user.name || user.username}
								/>
								<AvatarFallback>{fallbackInitials}</AvatarFallback>
							</Avatar>
						</Button>
					</SheetTrigger>
					<SheetContent side="right">
						<SheetHeader>
							<SheetTitle>{user.name}</SheetTitle>
							<p className="text-sm font-medium leading-none">{user.email}</p>
						</SheetHeader>
						<Spacer size="3xs" />
						<Button
							variant={pathname.includes('settings') ? 'secondary' : 'ghost'}
							className="w-full"
							asChild
							onClick={() => setIsOpen(false)}
						>
							<Link to="/settings/profile">Profile</Link>
						</Button>
						<div className="h-2" aria-hidden />
						<Form action="/logout" method="POST" ref={formRef}>
							<Button variant="outline" className="w-full" type="submit">
								Log out
							</Button>
						</Form>
					</SheetContent>
				</Sheet>
			</div>
		</>
	)
}
